import PURPOSES from '../definitions/Purpose';


/**
 * Gets the top-level purpose (ie. transaction type) from a specific purpose (or purpose subtype).
 * 
 * @param {PURPOSES[keyof PURPOSES]} purpose
 * @returns {string} transactionType
 */
function getTransactionTypeFromPurpose(purpose) {
    switch (purpose) {
        case PURPOSES.PURCHASE_FOUND_PROPERTY:
        case PURPOSES.PURCHASE_STILL_LOOKING:
        case PURPOSES.PRE_APPROVAL:
            return PURPOSES.PURCHASE;

        case PURPOSES.REFINANCE_ACCESS_EQUITY:
        case PURPOSES.REFINANCE_CONSOLIDATE_DEBT:
        case PURPOSES.REFINANCE_LOWER_INTEREST:
        case PURPOSES.REFINANCE_OTHER:
            return PURPOSES.REFINANCE;

        // is not a sub-type (eg. renewal)
        default:
            return purpose;
    }
}

export default getTransactionTypeFromPurpose;